import axios from '@/axios/globalaxios'
//查看币种调整目标

export const  findTargetAmountByAcid = (data) =>{
  return axios({
    url : '/tradelab/currency_files/findTargetAmountByAcid',
    method: 'post',
    data:data
  })
}